import {general} from './general'
/**
 * All api calls
 *
 * @class api
 */
class api {
  

  /**
   *
   * 
   * @static
   * @memberof api
   */
  static general = general;


  

}
export { api };

